<script>
import Util from "@/Util"
import moment from 'moment';
import "moment/locale/ja";
moment.locale('ja');

export default {
  computed:{
    logger:function (){
      return window.logger;
    }
  },
  methods: {

    buildApiServerUrl(path) {
      return Util.combineUrl(process.env.VUE_APP_API_HOST, path)
    },

    // Array判定
    isArray(item) {
      return Object.prototype.toString.call(item) === '[object Array]';
    },

    // OBJECT判定
    isObject(item) {
      return typeof item === 'object' && item !== null && !this.isArray(item);
    },

    // -------------------------------------------
    // 各種フォーマット(その他)
    // -------------------------------------------

    formatDateToDisplay(dt){
      if (dt){
        return moment(dt).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    formatDateTimeToJSON(dt){
      if (dt){
        return moment(dt).format()
      } else {
        return "";
      }
    },

    // -------------------------------------------
    // コード変換
    // -------------------------------------------

    getEvaluateItemList(){
      return ["quality","price","delivery","skill","capacity","person","future"]
    },

    getEvaluateItemName(code){
      switch (code){
        case 'quality':return "品質"
        case 'price':return "価格"
        case 'delivery':return "納期"
        case 'skill':return "技術"
        case 'capacity':return "キャパシティ"
        case 'person':return "人物"
        case 'future':return "将来性"
        default:return "?"
      }
    },

    getEquipmentName(code){
        if (code){
          let a = this.$store.state.equipmentMap[code];
          if (a) {
            return a.equipmentName
          }
        }
        return ""
    },

    getItemGroupName(code){
      if (code){
        let a = this.$store.state.itemGroupMap[code];
        if (a) {
          return a.itemGroupName
        }
      }
      return ""
    },

  },
}
</script>